module.exports = __webpack_public_path__ + "img/13.cb08b1f6.jpg";